function get_operator(logic) {
  return Object.keys(logic)[0];
}

export default get_operator;
